import request from '@/api/request'

export function login(data) {
  return request({
    url: '/token/login',
    method: 'post',
    data: data
  })
}
export function home(data) {
  return request({
    url: '/home',
    method: 'post',
    data: data
  })
}
export function keywordList(data) {
  return request({
    url: '/keyword_to_list',
    method: 'post',
    data: data
  })
}
export function answerDetails(data) {
  return request({
    url: '/answer_details',
    method: 'post',
    data: data
  })
}
export function answerDetails2(data) {
  return request({
    url: '/nbbank_answer_details',
    method: 'post',
    data: data
  })
}
export function classifyList(data) {
  return request({
    url: '/classify_list',
    method: 'post',
    data: data
  })
}
export function catalogList(data) {
  return request({
    url: '/catalog_list',
    method: 'post',
    data: data
  })
}
export function catalogList2(data) {
  return request({
    url: '/nbbank_catalog_list',
    method: 'post',
    data: data
  })
}


// WEBPACK FOOTER //
// ./src/api/index.js